module.exports = __webpack_public_path__ + "img/menu2.8e02557d.svg";